import { Card } from '@/components/ui/card';
import { Circle, History, ArrowRight } from 'lucide-react';

export default function TimingWindows({ windows }) {
    if (!windows) return null;
    return (
        <div className="grid md:grid-cols-3 gap-4" data-testid="timing-windows">
            <Column title="Ongoing" color="emerald" icon={Circle} items={windows.ongoing || []} />
            <Column title="Past" color="slate" icon={History} items={(windows.past || []).slice(-5).reverse()} />
            <Column title="Future" color="sky" icon={ArrowRight} items={(windows.future || []).slice(0, 5)} />
        </div>
    );
}

const COLOR = {
    emerald: 'border-l-emerald-500/70',
    slate: 'border-l-slate-500/40',
    sky: 'border-l-sky-500/60',
};

function Column({ title, color, icon: Icon, items }) {
    return (
        <Card className={`bg-surface border-marigold/10 rounded-sm p-5 border-l-4 ${COLOR[color]}`} data-testid={`timing-${title.toLowerCase()}`}>
            <div className="flex items-center gap-2 mb-4 text-slate-300">
                <Icon size={16} />
                <span className="overline !text-xs !tracking-widest">{title}</span>
                <span className="text-xs text-slate-600 ml-auto">{items.length}</span>
            </div>
            {items.length === 0 ? (
                <div className="text-xs text-slate-600">—</div>
            ) : (
                <ul className="space-y-3 text-sm">
                    {items.map((it, i) => (
                        <li key={i} className="border-t border-marigold/5 pt-3 first:border-t-0 first:pt-0">
                            <div className="flex items-center gap-2">
                                <span className="text-marigold font-medium">{it.lord}</span>
                                <span className="text-[10px] uppercase tracking-wider text-slate-500">{it.level}</span>
                            </div>
                            <div className="text-xs text-slate-500 mt-1">
                                {fmt(it.start)} → {fmt(it.end)}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </Card>
    );
}

function fmt(iso) {
    try {
        const d = new Date(iso);
        return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    } catch { return iso; }
}
